import PropTypes from "prop-types";
import { useEffect, useState } from "react";

// Layouts
import CustomizedSwitches from "@/Layouts/components/InputComponents/CustomizedSwitches";
import DoubleCheckingButton from "@/Layouts/components/Buttons/DoubleCheckingButton";
import InputValue from "@/Layouts/components/InputComponents/InputValue";
import SimpleTextField from "@/Layouts/components/InputComponents/SimpleTextField";

// MUI
import { Grid, SvgIcon, Typography } from "@mui/material";

// Icons
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import { ReactComponent as TrashIcon } from "@/assets/icons/actions/trash.svg";
import clsx from "clsx";

export default function PackItem(props) {
	const {
		index = 0,
		pack = {
			title: "",
			amount: {
				input: "Dollar",
				value: 0,
			},
			soft: false,
		},
		deleteTitle = "Remove",
		errors = null,
		readOnly = false,
		onActionDelete = () => {},
		onActionUpdate = () => {},
	} = props;

	const [innerPack, setInnerPack] = useState({
		title: "",
		amount: { input: "Dollar", value: 0 },
		soft: false,
	});

	const updatePack = (area, value) => {
		const updated = { ...innerPack };
		if (area === "amount") {
			const updatedValue = value ? Number(value) : 0;
			updated[area] = { input: "Dollar", value: updatedValue };
		} else {
			updated[area] = value;
		}

		setInnerPack(updated);
		onActionUpdate?.(index, updated);
	};

	useEffect(() => {
		setInnerPack(pack);
		return () => {
			setInnerPack({
				title: "",
				amount: { input: "Dollar", value: 0 },
				soft: false,
			});
		};
	}, [pack]);

	return (
		<Grid container direction="row" justifyContent="flex-start" alignItems="center" alignContent="center" columnSpacing={2}>
			<Grid item sx={{ minWidth: "200px" }}>
				<Typography className="draw-label" sx={{ textAlign: "center", display: index ? "none" : "inherit" }}>
					Name
				</Typography>

				<SimpleTextField
					outlined
					text={innerPack.title}
					editable={!readOnly}
					error={errors?.title}
					readOnly={readOnly}
					onActionUpdate={(value) => updatePack("title", value)}
				/>
			</Grid>

			<Grid item sx={{ maxWidth: "110px" }}>
				<Typography className="draw-label" sx={{ textAlign: "center", display: index ? "none" : "inherit" }}>
					Amount
				</Typography>

				<InputValue
					data={[
						{
							type: "Dollar",
							min: 0,
							max: 10000,
							decimals: 2,
							decimalsEditable: true,
						},
					]}
					value={innerPack.amount?.value || 0.0}
					error={errors?.amount}
					readOnly={readOnly}
					onActionUpdate={(value) => updatePack("amount", value)}
				/>
			</Grid>

			<Grid item sx={{ minWidth: "115px" }}>
				<Typography
					className="draw-label"
					sx={{ visibility: props.index ? "hidden" : "collapse", display: props.index ? "none" : "inherit" }}
				>
					Switch
				</Typography>
				<CustomizedSwitches
					textRight
					textChecked="Soft"
					textUnChecked="Hard"
					checked={innerPack.soft}
					disabled={readOnly}
					onChange={(value) => updatePack("soft", value)}
				/>
			</Grid>

			<Grid item ml={"-10px"} sx={{ paddingLeft: "0px !important" }}>
				<Typography
					className="draw-label"
					sx={{ visibility: props.index ? "hidden" : "collapse", display: props.index ? "none" : "inherit" }}
				>
					Remove
				</Typography>

				<DoubleCheckingButton
					title={deleteTitle}
					icon={<CloseRoundedIcon />}
					iconHover={<CloseRoundedIcon />}
					endIcon={<SvgIcon className="!text-[16px] ml-[4px]" component={TrashIcon} viewBox={"0 0 14 14"} />}
					mainButtonClasses={"btn-simple-remove"}
					confirmationSx={{ right: 0, left: "10px", maxWidth: "98px" }}
					disabled={readOnly}
					onDeleteAction={() => onActionDelete?.(index)}
				/>
			</Grid>
		</Grid>
	);
}
PackItem.propTypes = {
	index: PropTypes.number,
	pack: PropTypes.shape({
		title: PropTypes.string,
		amount: PropTypes.shape({
			input: PropTypes.string,
			value: PropTypes.number,
		}),
		soft: PropTypes.bool,
	}),
	deleteTitle: PropTypes.string,
	errors: PropTypes.object,
	readOnly: PropTypes.bool,
	onActionDelete: PropTypes.func,
	onActionUpdate: PropTypes.func,
};
